<template>
     <div class="dashboard-table-row table-row-v2 mb-3">
        <div class="dashboard-table-column text-wrap text-center d-block">
            <p>Совершая оплату вы  подтверждаете, что оплачиваете со своего счета KSB и согласны на ручную проверку транзакции, которая может занять до 8 часов.</p>
            <hr>
            <p>Для проведения платежа, отсканируйте QR-код в приложении банка:</p>
        </div>
    </div>
    <div class="modal-qr-image modal-qr-mkassa mb-3">
        <img :src="detail.qrCode" :alt="detail.description">
    </div>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>